import {
  BuySellTransaction,
  FundTransactionDetail,
  SessionType,
} from 'interfaces'

export function mapFundToTransaction(
  data: FundTransactionDetail,
): BuySellTransaction {
  return {
    id: data?.asset?.id,
    title: data?.asset?.name,
    status: data?.status,
    statusText: data?.statusText,
    childStatus: data?.childStatus,
    childStatusText: data?.childStatusText,
    reason: null,
    reasonText: null,
    documentId: data?.documentId,
    ticker: data?.asset?.ticker,
    amount: data?.calculations?.totalCost,
    date: data?.creationDate,
    logo: data?.asset?.logoUrl,
    asset: {
      currency: data?.asset?.currency,
      id: data?.asset?.id,
      isin: data?.asset?.isin,
      logoUrl: data?.asset?.logoUrl,
      market: null,
      name: data?.asset?.name,
      ticker: data?.asset?.ticker,
      session: SessionType.regular,
    },
    transferTargetAsset: {
      id: data?.targetAsset?.id,
      ticker: data?.targetAsset?.ticker,
      isin: data?.targetAsset?.isin,
      currency: data?.targetAsset?.currency,
      name: data?.targetAsset?.name,
      logoUrl: data?.targetAsset?.logoUrl,
      units: data?.targetAsset?.units,
      nav: data?.targetAsset?.nav,
    },
    orderMethod: data?.method,
    type: data?.type,
    shares: null,
    units: data?.units,
    taxes: null,
    fees: null,
    totalCost: data?.calculations?.totalCost,
    lockedCash: null,
    netAmount: data?.calculations?.netAmount,
    netAmountInPortfoliosCurrency:
      data?.calculations?.netAmountInPortfolioCurrency,
    requiredNetAmount: null,
    exchangeRateAverage: data?.exchangeRateAverage,
    expirationDate: null,
    estimatedPrice: data?.calculations?.totalCost,
    nav: data?.nav,
    executedPrice: null,
    grossAmount: data?.calculations?.grossAmount,
    assetCurrency: data?.asset?.currency,
    contingenciesBuffer: null,
    contingenciesBufferAmount: null,
    isCancellable: data?.isCancellable,
    notCancellableReason: data?.notCancellableReason,
    commissions: {
      custodyFees: null,
      executionFees: null,
      financialInstrumentFees: null,
      forexFees: null,
      thirdPartyPayments: null,
      totalCommission: data?.commissions?.totalCommission,
    },
    cutOffTime: data?.cutOffTime,
    completedDate: data?.completedDate,
    creationDate: data?.creationDate,
    cancellationDate: null, // TBD
  }
}
